export const API_URL = `${process.env.API_URL_PREFIX}/`;
export const JWT_SECRET = '123456' as string;